import React from 'react'
import './portfolio.css'
import IMG1 from './../../assets/Project6.png'
import IMG2 from './../../assets/Project2.png'
import IMG3 from './../../assets/Project3.png'
import IMG4 from './../../assets/Project4.png'
import IMG5 from './../../assets/Project5.png'

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        <article className="portfolio__item">
         <div className="portfolio__item-image">
           <img src={IMG1} alt="" />
         </div>
          <h3>Museum Application <br /> (full stack)</h3>
          <div className="portfolio__item-cta">
           <a href="https://github.com/Tariqkharsa/Final_Team_12_Museum" target="_blank" rel="noreferrer" className='btn'>GitHub</a>
           <a href="https://youtu.be/vYkbb15-AE0" target="_blank" rel="noreferrer" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>
        <article className="portfolio__item">
         <div className="portfolio__item-image">
           <img src={IMG2} alt="" />
          </div>
          <h3>Reinforcement Learning Agent (AI)</h3>
          <div className="portfolio__item-cta">
           <a href="https://github.com/Tariqkharsa/Reinforcement-Learning-Agent" target="_blank" rel="noreferrer" className='btn'>GitHub</a>
           <a href="https://youtu.be/kaOd-75ssLQ" target="_blank" rel="noreferrer" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>
        <article className="portfolio__item">
         <div className="portfolio__item-image">
           <img src={IMG3} alt="" />
          </div>
          <h3>Image Processing</h3>
          <div className="portfolio__item-cta">
           <a href="https://github.com/Tariqkharsa/Digital-Image-Processing" target="_blank" rel="noreferrer" className='btn'>GitHub</a>
           <a href="https://youtu.be/oQOxKf7ZiDk" target="_blank" rel="noreferrer" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>
        <article className="portfolio__item">
         <div className="portfolio__item-image">
           <img src={IMG4} alt="" />
          </div>
          <h3>BERT NLP (AI)</h3>
          <div className="portfolio__item-cta">
           <a href="https://github.com/Tariqkharsa/BERT-MODEL" target="_blank" rel="noreferrer" className='btn'>GitHub</a>
           <a href="https://youtu.be/93A7v9hOMr0" target="_blank" rel="noreferrer" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>
        <article className="portfolio__item">
         <div className="portfolio__item-image">
           <img src={IMG5} alt="" />
          </div>
          <h3>C++ Server <br /> (Sockets)</h3>
          <div className="portfolio__item-cta">
           <a href="https://github.com/Tariqkharsa/C-Server" target="_blank" rel="noreferrer" className='btn'>GitHub</a>
           <a href="https://youtu.be/nZbb-yKXLPw" target="_blank" rel="noreferrer" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>
      </div>
    </section>
  )
}

export default Portfolio